// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiPushNotificationSettingsUpdate {
    'identity_subscribed'?: boolean;
    'identity_mentioned'?: boolean;
    'identity_rep'?: boolean;
    'identity_nic'?: boolean;
    'drop_quoted'?: boolean;
    'drop_replied'?: boolean;
    'drop_voted'?: boolean;
    'drop_reacted'?: boolean;
    'drop_boosted'?: boolean;
    'wave_created'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "identity_subscribed",
            "baseName": "identity_subscribed",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "identity_mentioned",
            "baseName": "identity_mentioned",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "identity_rep",
            "baseName": "identity_rep",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "identity_nic",
            "baseName": "identity_nic",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "drop_quoted",
            "baseName": "drop_quoted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "drop_replied",
            "baseName": "drop_replied",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "drop_voted",
            "baseName": "drop_voted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "drop_reacted",
            "baseName": "drop_reacted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "drop_boosted",
            "baseName": "drop_boosted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "wave_created",
            "baseName": "wave_created",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiPushNotificationSettingsUpdate.attributeTypeMap;
    }

    public constructor() {
    }
}
